import React, { Component }     from "react";
import { Button, PageHeader, DropdownButton, MenuItem, Panel, Row,Tab, Tabs, Col } from "react-bootstrap";
import BootstrapTable           from 'react-bootstrap-table-next';
import ModalCreateFolder        from "../../components/modal/ModalCreateFolder";
import ModalMoveProgramToFolder from "../../components/modal/ModalMoveProgramToFolder";
import ModalTrainerDetail       from "../../components/modal/ModalTrainerDetail";
import ModalAlert               from "../../components/modal/ModalAlert";
import uniqueId                 from 'lodash/uniqueId';
import config                   from "../../config";
import RenderLander             from "../../components/utils/RenderLander";
import BillingForm              from "../../screens/billing/BillingForm";
import { Colors }               from "../../utils/Colors";
import ModalTrainerTextMsg                 from "../../components/modal/ModalTrainerTextMsg";
import { invokeGetTemplateSpendReport }   from "../../utils/AwsInvoke";
import { doesTrainerHaveValidPhoneNumber } from "../../utils/CheckIfValidPhoneNumber";
import "../../css/report/ReportDashboard.css";

/*function priceFormatter(column, colIndex) {
  return (
    <h5><strong>{ column.text }</strong></h5>
  );
}
const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    hideSelectColumn: true,
    bgColor: "#fff"
};*/

var template_spend_summ_arr = [];
var template_details_arr    = []; ///*{id: 1,name: "Product1",price: 120,}*/

//  ALL HTML tags MUST be removed for the SORT feature to work on a table  //
const columns_summary = [{
    dataField: "trainer_name",
    text: "Trainer",
    sort: true,
    headerStyle: () => {
        return { width: "15%", textAlign: "center", outline: 0, border: 0 };
    }
},{
    dataField: "price",
    text: "Templates Sent",
    //sort: true,
    headerStyle: () => {
        return { width: "5%", textAlign: "center" };
    }
},{
    dataField: "bundle_price",
    text: "Bundle Spend",
    sort: false,
    headerStyle: () => {
        return { width: "5%", textAlign: "center" };
    }
},{
    dataField: "total_price",
    text: "Total Spend",
    headerStyle: () => {
        return { width: "5%", textAlign: "center" };
    }
}]; /*{
    dataField: "last_login",
    text: "Last Login",
    //sort: true,
    headerStyle: () => {
        return { width: "16%", textAlign: "center" };
    }
}, {
    dataField: "sms_icon",
    text: "Msg Trainer",
    headerStyle: () => {
        return { width: "9%", textAlign: "center" };
    }
    //headerFormatter: priceFormatter
}];*/
const columns = [{
    dataField: "trainer_name",
    text: "Trainer",
    sort: true,
    headerStyle: () => {
        return { width: "15%", textAlign: "center", outline: 0, border: 0 };
    }
},{
    dataField: "price",
    text: "Price",
    //sort: true,
    headerStyle: () => {
        return { width: "5%", textAlign: "center" };
    }
},{
    dataField: "athlete_name",
    text: "Athlete",
    //sort: true,
    headerStyle: () => {
        return { width: "15%", textAlign: "center" };
    }
},{
    dataField: "program",
    text: "Program",
    sort: true,
    headerStyle: () => {
        return { width: "25%", textAlign: "center" };
    }
},{
    dataField: "template_id",
    text: "Template Id",
    //sort: true,
    headerStyle: () => {
        return { width: "15%", textAlign: "center" };
    }
},{
    dataField: "template_price_uid",
    text: "UID",
    //sort: true,
    headerStyle: () => {
        return { width: "15%", textAlign: "center" };
    }
},{
    dataField: "program_date_created",
    text: "Date",
    sort: true,
    headerStyle: () => {
        return { width: "5%", textAlign: "center" };
    }
}];

export default class TemplateAnalysis extends Component {
    constructor(props) {
        super(props);
        var globalCompanyId       = sessionStorage.getItem('company_id');
        var globalAdminUserId     = localStorage.getItem('globalAdminUserId');
        var globalAdminUserEmail  = localStorage.getItem('globalAdminUserEmail');
        var globalAdminUserRoleId = localStorage.getItem('globalAdminUserRoleId');

        this.state = {
          isLoading: true,
          exerciseSaved: false,
          adminUserId:     globalAdminUserId,
          adminCompanyId:  globalCompanyId,
          adminUserEmail:  globalAdminUserEmail,
          adminUserRoleId: globalAdminUserRoleId,
          //showModalTrainerTextMsg: false,
          //showModalTrainerDetail: false,
          //showModalAlert: false
        };
    }

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            var role_id    = this.state.adminUserRoleId;
            var trainer_id = this.state.adminUserId; //"b569d320-5c19-11e9-bda3-8726ddea8a40";// info accelerate - this.state.trainerId;

            this.getTrainerDetail(trainer_id, role_id);
        } catch (e) {
            alert(e);
        }
    }

    componentWillUnmount () {
        this.setState({
            showModalTrainerDetail: false,
            showModalTrainerTextMsg: false,
            showModalAlert: false
        })
    }

    getTrainerDetail = async (trainer_id, role_id) => {

        var number_of_total_results   = 200;
        const results = await invokeGetTemplateSpendReport(trainer_id, role_id);

        if(results) {

            var spend_summary       = results.data.spend_summary;
            var template_usage_data = results.data.template_usage_data;

            /*for(var key in spend_summary) {
                console.log("key: " + key);
                console.log("spend_summary: "+ spend_summary[key]);
                var spend_summary2 = spend_summary[key];
                console.log("-------------------");
                for(var key2 in spend_summary2) {
                    console.log("key2: " + key2);
                    console.log("spend_summary2: " + spend_summary2[key2]);
                }
            }*/
            this.getTemplateSpend(spend_summary, template_usage_data);

            this.setState({
                //trainerDetail: trainer_data,
                showModalTrainerDetail: false,
                showModalTrainerTextMsg: false,
                showModalAlert: false
            })
        }
    }

    ////   SHOW THE ALERT MODAL   ////
    setModalAlertProps = (title_text, body_text, show_modal) => {
        var alert_object = {};
        var alert_action = "";

        this.setState({
            modalAlertTitleText: title_text,
            modalAlertBodyText:  body_text,
            showModalAlert:      show_modal, // true | false
            alertObject:         alert_object,
            alertAction:         alert_action
        })
    }

    sms = (trainer_id, trainer_name, trainer_phone, athlete_id, athlete_name, athlete_last_login, program_name) => {
        var trainer_number = doesTrainerHaveValidPhoneNumber(trainer_phone);

        if(trainer_number == false) {
            //alert("Sorry, before you send a text message, you need to add a valid trainer number.")
            var body_text  = "Sorry, before you send a text message, you need to add a valid trainer number.";
            this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
            this.setState({ isLoading: false, showLoadingBar: "none" });
            return false;
        }

        this.setState({
            showModalTrainerTextMsg: true,
            trainerId:               trainer_id,
            trainerName:             trainer_name,
            trainerTextPhone:        trainer_number,
            athleteId:               athlete_id,
            athleteName:             athlete_name,
            athleteLastLogin:        athlete_last_login,
            programName:             program_name,
        });
    }


    gotoClientProfile (athlete_id) {
        this.props.history.push("/client/detail/"+athlete_id);
    }

    gotoTrainerProfile (trainer_id, trainer_full_name, company_id, company_name, phone, email) {

        /*console.log("Trainer_id: " + trainer_id);
        console.log("company_id: " +  company_id);
        console.log("company_name: " +  company_name);
        console.log("phone: " + phone);
        console.log("email: " + email);*/

        var location_abbrev;

        if(company_id == "001877c0-ebf1-11e9-a945-d5dded95ac71") {
            location_abbrev = "hayes";
            //company_name = "P4L Training - Hayes Valley"
        } else if(company_id == "c84934b0-ebf0-11e9-911a-fbdac363f28e") {
            location_abbrev = "fidi";
            //company_name = "P4L Training - FiDi";
        } else if(company_id == "4b07edc0-ebf0-11e9-85dd-9b2fcf560e30") {
            location_abbrev = "castro";
            //company_name = "P4L Training - Market/Castro";
        }

        this.setState({
            showModalTrainerDetail: true,
            trainerId:              trainer_id,
            trainerName:            trainer_full_name,
            trainerPhoneNum:        phone,
            trainerEmail:           email,
            trainerCompanyId:       company_id,
            trainerCompanyName:     company_name,
            showTrainerForm:        false,
            trainerLocationAbbrev:  location_abbrev,
        });

        /*trainerLocationAbbrev  = {this.state.location_abbrev}*/
    }

    resetTrainerList = () => {
        //this.getMemberList();
        // empty function
    }

    getTemplateUsageData = (template_usage_data) => {
            template_details_arr    = []; //reset global array for table; req'd otherwise modals don't show if you veer away from page and then back to this page

            var ctr = 1;
            for(var key in template_usage_data) {
                    var data2 = template_usage_data[key];
                    var athlete_id         = data2.athlete_id;;
                    var template_id        = data2.template_id;
                    var athlete_first_name = data2.athlete_first_name;
                    var athlete_last_name  = data2.athlete_last_name;
                    var trainer_phone      = data2.trainer_phone;  // not used
                    var trainer_email      = data2.trainer_email;  // not used
                    var company_id         = data2.company_id;     // not used
                    var company_name       = data2.company_name;   // not used
                    var price              = "$1"; // data2.template_send_price;
                    var template_price_uid = data2.template_price_uid;

                    var trainer_id         = data2.trainer_id;
                    var trainer_first_name = data2.first_name;
                    var trainer_last_name  = data2.last_name;
                    var date_created       = data2.date_created;
                    var new_date           = new Date(date_created).toLocaleString([], {month: 'short', day:'2-digit'}); //, hour: '2-digit', minute:'2-digit'});
                    var athlete_name       = athlete_first_name + " " + athlete_last_name;
                    var trainer_full_name  = trainer_first_name + " " + trainer_last_name;
                    var date_last_used     = data2.ath_prog_date_last_used; // not used

                    var program_name       = data2.name;

                    //  ALL HTML tags MUST be REMOVED for the SORT feature to work  //
                    //  trainer_name: <span  key = {uniqueId()} className="reportDashClientName" style={{fontWeight: "bold"}}
                    //                     onClick={this.gotoTrainerProfile.bind(this, trainer_id, trainer_full_name, company_id, company_name, trainer_phone, trainer_email)}>

                        template_details_arr.push({
                              id: uniqueId(), // id is required for unique keys, otherwise there's an error
                              trainer_name: ctr + ". " + trainer_full_name,
                              price:        <span  className="reportDashClientName" style={{cursor: "none"}}>{price}</span>,
                              athlete_name: <span  className="reportDashClientName"
                                                   style={{cursor: "none"}}
                                                   //onClick={this.gotoClientProfile.bind(this, athlete_id)}
                                                   >
                                                       {athlete_name}
                                            </span>,
                              program:      <span  className="reportDashClientName" style={{cursor: "none"}}>{program_name}</span>,
                              template_id:  <span  className="reportDashClientName" style={{cursor: "none"}}>{template_id}</span>,
                              template_price_uid:  <span  className="reportDashClientName" style={{cursor: "none"}}>{template_price_uid}</span>,
                              program_date_created: new_date
                          })
                        ctr++;
                    //}
            }
    }


    getTemplateSummaryData = (spend_summary) => {
            template_spend_summ_arr = [];
            var ctr = 1;

            for(var key in spend_summary) {
                var data2 = spend_summary[key];
                var trainer_count      = data2.trainer_count; // count the number of priced templates sent to a trainer's client
                var price              = 1 * trainer_count;
                var creator_id         = data2.creator_id;
                var trainer_first_name = data2.first_name;
                var trainer_last_name  = data2.last_name;
                //var date_created       = data2.date_created;
                //var new_date           = new Date(date_created).toLocaleString([], {month: 'short', day:'2-digit'}); //, hour: '2-digit', minute:'2-digit'});
                var trainer_full_name  = trainer_first_name + " " + trainer_last_name;
                var bundle_price       = 27;
                var total_price        = price + 27;

                // ALL HTML tags ust be removed for the SORT feature to work on a table //
                /*trainer_name: <span  key = {uniqueId()}
                                     className="reportDashClientName"
                                     style={{fontWeight: "bold"}}>
                                      { ctr + ". " + trainer_full_name }
                              </span>*/

                template_spend_summ_arr.push({
                      id: uniqueId(), // id is required for unique keys, otherwise there's an error
                      trainer_name: ctr  + ". " + trainer_full_name,
                      price:        <span  className="reportDashClientName" style={{display:"inline-block", width: "100%", cursor: "none", textAlign: "center"}}>${price}</span>,
                      bundle_price: <span  className="reportDashClientName" style={{display:"inline-block", width: "100%", cursor: "none", textAlign: "center"}}>${bundle_price}</span>,
                      total_price:  <span  className="reportDashClientName" style={{display:"inline-block", width: "100%", cursor: "none", textAlign: "center"}}><b>${total_price}</b></span>,
                  })
                ctr++;
            }
    }

    getTemplateSpend (spend_summary, template_usage_data) {
        this.getTemplateUsageData(template_usage_data)
        this.getTemplateSummaryData(spend_summary)
    }

    renderHome() {
        var customer_company = this.props.globalCompanyName; //process.env.REACT_APP_COMPANY_NAME;
        var exercise_saved;
        var tab2 = <div></div>;
        var tab3;
        var adminUserRoleId = this.state.adminUserRoleId;
        var user_role       = "Employee";
        //var show_trainers   = false;
        var company_id      = this.props.globalCompanyId;
        //console.log("adminUserRoleId: " + adminUserRoleId);


        if(this.state.exerciseSaved)
            exercise_saved   = "Selection Saved.";

        return (
              <div className="programs">

                    <br/><br/>
                    <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
                              <Tab eventKey={1} title="Spend Summary">
                                    <br/> &nbsp;  &nbsp; Monthly spend summary per trainer.<br/>
                                    <br/>
                                    <BootstrapTable keyField  = "id"
                                                    key       = {uniqueId()}
                                                    data      = { template_spend_summ_arr }
                                                    columns   = { columns_summary }
                                                    striped hover
                                                    //selectRow = { selectRow }
                                                    />
                               </Tab>
                               <Tab eventKey={2} title="Template Usage">
                                    <br/> &nbsp;  &nbsp; Detailed view of all the templates sent from the trainer to the athlete.<br/>
                                    <br/>
                                     <BootstrapTable keyField  = "id"
                                                     key       = {uniqueId()}
                                                     data      = { template_details_arr }
                                                     columns   = { columns }
                                                     striped hover
                                                     //selectRow = { selectRow }
                                                     />
                                </Tab>
                              { /*}<Tab eventKey={3} title="Charts">

                              </Tab> */}
                  </Tabs>
              </div>
        );
    }

    render() {
        let closeModalAlert          = () => this.setState({ showModalAlert: false }); //close simple modal window
        let closeModalTrainerDetail  = () => this.setState({ showModalTrainerDetail: false }); //close simple modal window
        let closeModalTrainerTextMsg = (error) => this.setState({ showModalTrainerTextMsg: false, error: error }); //close modal window


        return (
              <div className="Home">
                {this.renderHome()}

                  {this.state.showModalAlert ?
                      <ModalAlert
                          onHide         = {closeModalAlert}
                          alertFunction  = {this.alertFunction}     // custom function to call within modal
                          alertAction    = {this.state.alertAction} // flag used for above function
                          alertObject    = {this.state.alertObject} // vars used for above function
                          showModalAlert = {this.state.showModalAlert}
                          messageTitle   = {this.state.modalAlertTitleText}
                          messageBody    = {this.state.modalAlertBodyText}
                      />
                  : null}
                  {this.state.showModalTrainerDetail ?
                    <ModalTrainerDetail
                        show                  = {this.state.showModalTrainerDetail}
                        trainerName           = {this.state.trainerName}
                        trainerId             = {this.state.trainerId}
                        trainerPhoneNum       = {this.state.trainerPhoneNum}
                        trainerEmail          = {this.state.trainerEmail}
                        trainerCompanyId      = {this.state.trainerCompanyId}
                        trainerCompanyName    = {this.state.trainerCompanyName}
                        showTrainerForm       = {this.state.showTrainerForm}
                        resetTrainerList      = {this.resetTrainerList}
                        trainerLocationAbbrev = {this.state.trainerLocationAbbrev}
                        onHide={closeModalTrainerDetail}
                    />
                : null}
                {this.state.showModalTrainerTextMsg ?
                      <ModalTrainerTextMsg
                          onHide                  = {closeModalTrainerTextMsg}
                          trainerId               = {this.state.trainerId}
                          trainerName             = {this.state.trainerName}
                          trainerPhone            = {this.state.trainerTextPhone}
                          athleteId               = {this.state.athleteId}
                          athleteName             = {this.state.athleteName}
                          athleteLastLogin        = {this.state.athleteLastLogin}
                          programName             = {this.state.programName}
                          showModalTrainerTextMsg = {this.state.showModalTrainerTextMsg}
                      />
                 : null}
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/trainer/TemplateAnalysis.js